import React from "react";
import Div from "../lib/Div";
import P from "../lib/P";

type Props = {name?: string, size: number};

const UserAvatarProps = (props: Props) => {
  const {name, size} = props;

  const getInitials = () => {
    if (!name) return '';
    const trimmedName = name.trim();
    if (!trimmedName) return '';

    const words = trimmedName.split(/\s+/);

    if (words.length === 1) {
      return words[0].slice(0, 1).toUpperCase();

    } else {
      return words[0].slice(0, 1).toUpperCase() + words[1].slice(0, 1).toUpperCase();
    }
  };

  return (
    <Div w={size} h={size} rounded={size / 2} bg="#214ECC" alignItems="center" justifyContent="center">
      <P fontFamily="DavisSans-Regular" fs={14}>{getInitials() || '?'}</P>
    </Div>
  );
};

export default React.memo(UserAvatarProps);
